<template>
  <div class="recharge">
    <div class="recharge__card">
      <RechargeCard @emitSlotEvent="emitSlotEvent" :slots="slots" :items="items" origin="Slots">
        <template #slot1> {{ calculateMin }} </template>
        <template #slot2>
          <span v-if="slots?.slot_type_billing === 'Postpago'">{{ slots?.slots_invoice }}</span>
          <span v-else>{{ tableSlots }}</span>
        </template>
        <template #slot3> {{ slots?.slot_assigned }} </template>
        <template #slot4> ${{ slots?.slot_price }} </template>
      </RechargeCard>
      <div>
        <SlotsTable ref="SlotsTableRef" :slots="slots" />
      </div>
    </div>
    <div class="recharge__summary">
      <SlotsPaymentCard ref="rechargeRef" :slots="slots" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from "vue";
import SlotManager from "@/app/settings/services/slots/SlotManager";
import RechargeCard from "@/app/settings/components/cards/RechargeCard.vue";
import { ISlots, IItems } from "@/@types/settings/slots";
import SlotsPaymentCard from "../cards/SlotsPaymentCard.vue";
import SlotsTable from "../tables/SlotsTable.vue";
import EventBus from "@/app/shared/utils/eventBus";

const manager = new SlotManager();

const slots = ref<ISlots>();
const SlotsTableRef = ref<InstanceType<typeof SlotsTable>>();

const tableSlots = computed(() => {
  const tableData = SlotsTableRef.value?.tableData as unknown as { count: number; results: any[] };

  return tableData?.count;
});

// si al crear el tenant o hacer edicion/upg/down se pone un monto menor al default se setea en slot_max
const calculateMin = computed(() => {
  const min = slots.value?.slot_min || 1;
  const max = slots.value?.slot_min || 1;

  return min < max ? min : max
})

const items: IItems[] = [
  {
    title: "N° de slots mín por contrato:",
    subtitle: "N° slots mínimos a cobrar",
  },
  {
    title: "N° total de slots a facturar:",
    subtitle: "N° de slots totales en el mes",
    tooltip: true,
  },
  {
    title: "Slots utilizados:",
    subtitle: "N° de usuarios actuales en plataforma",
  },
  {
    title: "Precio por slot:",
    tooltip: true,
  },
];

const fetchSlots = async () => {
  const response = await manager.getInfoSlots();
  console.log(response, "response");
  slots.value = response;
};

EventBus.on("updateSlots", () => {
  fetchSlots();
});

onMounted(() => {
  fetchSlots();
});

watch(
  () => slots.value?.slots_invoice,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      fetchSlots();
    }
  },
  { immediate: true }
);

const emit = defineEmits(["emitSlotEvent"]);

const emitSlotEvent = (message: string) => {
  emit("emitSlotEvent", message);
};
</script>
<style lang="sass" scoped>
.recharge
  display: flex
  flex-direction: row
  gap: 40px
  height: 100%

  &__summary
    width: 25%
  &__card
    width: 75%
</style>
